import { SILVERFORT_API_FIELDS } from '../../common/fields';
import { Button, ButtonStyles, Label, TextInput } from '@silverfort/sf-components';
import { FC, useCallback, useMemo, useState } from 'react';
import CopyIcon from '../../../Controls/Buttons/CopyIcon';
import AddAccountPopup from './AddAccountPopup';
import { UPDATE_ADFS_API_TOKEN, UPDATE_MFA_API_USER } from '../../containers/SilverfortApi/silverfortApiActions';

interface UserParams {
    user: string;
    pass: string;
}

interface AdfsAndMfaProps {
    fields: {
        [key: string]: {
            id: string;
            value: string | UserParams;
        };
    };
    dispatch: (action: { type: string; payload: any }) => void;
    save: () => Promise<{ ADFSAPIToken: string }>;
}

const AdfsAndMfa: FC<AdfsAndMfaProps> = ({ fields, dispatch, save }) => {
    const adfsApiToken = useMemo(
        () => fields[SILVERFORT_API_FIELDS.ADFS_API_TOKEN.ID] as { id: string; value: string },
        [fields]
    );
    const silverfortMfaApi = useMemo(
        () => fields[SILVERFORT_API_FIELDS.SILVERFORT_MFA_API.ID] as { id: string; value: UserParams },
        [fields]
    );

    const [silverfortMfaPopupOpen, setSilverfortMfaPopupOpen] = useState(false);

    const updateSilverfortMfaApi = useCallback(
        (user: string, pass: string) => {
            dispatch({
                type: UPDATE_MFA_API_USER,
                payload: {
                    fieldId: silverfortMfaApi.id,
                    value: { user, pass }
                }
            });
            save().then((updatedSettings) => {
                dispatch({
                    type: UPDATE_ADFS_API_TOKEN,
                    payload: {
                        fieldId: fields[adfsApiToken.id].id,
                        value: updatedSettings.ADFSAPIToken
                    }
                });
            });
        },
        [dispatch, save, silverfortMfaApi?.id, adfsApiToken?.id]
    );

    const openSilverfortMfaPopup = useCallback(() => {
        setSilverfortMfaPopupOpen(true);
    }, []);

    const closeSilverfortMfaPopup = useCallback(() => {
        setSilverfortMfaPopupOpen(false);
    }, []);

    return (
        <>
            <div className="flex flex-col py-4 gap-6">
                <div className="flex flex-col gap-2">
                    <Label text={SILVERFORT_API_FIELDS.SILVERFORT_MFA_API.NAME} />
                    <div className="flex gap-2">
                        <TextInput
                            readOnly
                            disabled
                            value={silverfortMfaApi?.value.user}
                            placeholder="Not added"
                            onChange={() => {}}
                            className="h-8 w-[256px]"
                        />
                        <Button
                            text={`${silverfortMfaApi?.value.user ? 'Update' : 'Add'}`}
                            buttonStyle={ButtonStyles.Primary}
                            onClick={openSilverfortMfaPopup}
                        />
                    </div>
                </div>
                {adfsApiToken && (
                    <div className="flex flex-col gap-2">
                        <Label text={SILVERFORT_API_FIELDS.ADFS_API_TOKEN.NAME} />
                        <div className="flex gap-2">
                            <TextInput
                                isPassword
                                value={adfsApiToken.value}
                                readOnly
                                className="h-8 w-[256px]"
                                onChange={() => {}}
                            />
                            <CopyIcon
                                value={adfsApiToken.value}
                                className="rounded-lg border border-sf-gray-200 h-8 w-8 justify-center hover:border-sf-primary-500"
                            />
                        </div>
                    </div>
                )}
            </div>
            {silverfortMfaPopupOpen && (
                <AddAccountPopup
                    open={silverfortMfaPopupOpen}
                    onClose={closeSilverfortMfaPopup}
                    onCreate={updateSilverfortMfaApi}
                    user={silverfortMfaApi?.value}
                />
            )}
        </>
    );
};

export default AdfsAndMfa;
